import React from "react";
import logo from "../../images/footer-logo.png";
import "./Footer.css";

const year = new Date().getFullYear();

const Footer = () => {
  return (
    <div className="mt-5">
      <footer className="footer py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="footer-content text-center">
                <img className="footer-logo" src={logo} alt="" />
                <p className="mt-3">&copy; {year} Nannu. All rights reserved</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
